import React, { useState, useEffect, useCallback } from 'react';
import api from '../api/api';
import dayjs from 'dayjs';
import { Table, Card, Typography, message, Input } from 'antd';
import RankBadge from '../components/RankBadge';
import columnsFactory from '../utils/columnsFactory';
import { TrophyOutlined, SearchOutlined } from '@ant-design/icons';
import usePageMeta from '../hooks/usePageMeta';

function PlayerStats() {
    const { Title, Text, Paragraph } = Typography;
    usePageMeta('玩家上榜統計 | 光暈戰記排行榜', 'https://twilightwarscloudflarereact.pages.dev/player-stats');
    const [playerData, setPlayerData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [totalRecords, setTotalRecords] = useState(0);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ['10', '20', '30'],
    });

    const fetchPlayerStats = useCallback(async (page, pageSize, search) => {
        setLoading(true);
        try {
            const response = await api.getPlayerStats(page, pageSize, search);

            setPlayerData(response.data);
            setTotalRecords(response.total);

        } catch (error) {
            console.error('Error fetching player stats:', error);
            message.error('獲取玩家統計失敗');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchPlayerStats(pagination.current, pagination.pageSize, searchText);
    }, [fetchPlayerStats, pagination, searchText]);

    // 搜尋功能
    const handleSearch = (value) => {
        setSearchText(value);
        setPagination(prev => ({ ...prev, current: 1 }));
    };

    // 處理分頁變更
    const handleTableChange = (paginationConfig) => {
        setPagination(prev => ({
            ...prev,
            current: paginationConfig.current,
            pageSize: paginationConfig.pageSize,
        }));
    };

    const rankRender = (text, record, index) => {
        const rank = (pagination.current - 1) * pagination.pageSize + index + 1;
        if (searchText) return <span>{rank}</span>;
        return <RankBadge rank={rank} />;
    };

    const columns = [
        columnsFactory.makeRankColumn(rankRender),
        columnsFactory.userIdColumn,
        columnsFactory.nicknameColumn,
        columnsFactory.topRankCountColumn,
    ];

    return (
        <div style={{ padding: '1.25rem' }}>
            <Card>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.25rem' }}>
                    <Title level={2} style={{ margin: 0 }}>
                        <TrophyOutlined style={{ marginRight: '0.5rem', color: '#FFD700' }} />
                        玩家上榜統計
                    </Title>
                </div>

                <div style={{ marginBottom: '1.25rem' }}>
                    <Input.Search
                        placeholder="搜尋用戶ID或暱稱..."
                        allowClear
                        enterButton={<SearchOutlined />}
                        size="large"
                        onSearch={handleSearch}
                        style={{ maxWidth: '25rem' }}
                    />
                </div>

                <div style={{ marginBottom: '1.25rem', fontSize: '0.875rem' }}>
                    <Paragraph> <Text> 📊 數據庫開始日期 2024-08-12 - {dayjs().format('YYYY-MM-DD')}</Text></Paragraph>
                    <Paragraph> <Text>📊 統計範圍：每日 07:54-07:57 時段的排行榜數據</Text></Paragraph>
                    <Paragraph> <Text>🏆 顯示所有曾經上過每日排行榜的玩家及其上榜次數</Text></Paragraph>
                </div>

                <Table
                    dataSource={playerData}
                    columns={columns}
                    rowKey="userid"
                    pagination={{
                        ...pagination,
                        total: totalRecords,
                        showTotal: (total, range) => `第 ${range[0]}-${range[1]} 項，共 ${total} 位玩家`
                    }}
                    loading={loading}
                    onChange={handleTableChange}
                    locale={{ emptyText: searchText ? '找不到相符的玩家' : '暫無數據' }}
                    scroll={{ x: 600 }}
                />
            </Card>
        </div>
    );
}

export default PlayerStats;


